export default {
  SET_TRENDING_INDICES_LOADING: (state, isLoading) => {
    state.trendingIndicesLoading = isLoading;
  },

  SET_TRENDING_INDICES: (state, payload) => {
    state.trendingIndices = payload;
  },

  SET_TRENDING_INDICES_ERROR: (state, er) => {
    state.trendingIndicesError = er;
  },

  SET_TRENDING_INDICES_PAGE: (state, page) => {
    state.trendingIndicesPage = page;
  },

  INCREMENT_TRENDING_INDICES_PAGE: (state) => {
    const totalIndices = state.trendingIndices?.length ?? 0;
    const totalPages =
      Math.ceil(totalIndices / state.trendingIndicesPageSize) || 1;
    state.trendingIndicesPage = (state.trendingIndicesPage + 1) % totalPages;
  },
};
